import { Mic, MicOff } from "lucide-react";

import { Button } from "@/components/ui/button";

interface MicButtonProps {
  onClick: () => void;
  isMuted: boolean;
  audioDetected: boolean;
  disabled: boolean;
  size?: "sm" | "md" | "lg";
  tourKey?: string;
}

export function MicButtonComponent({
  onClick,
  isMuted,
  audioDetected,
  disabled,
  size = "md",
  tourKey,
}: MicButtonProps) {
  // Size mappings
  const buttonSizes = {
    sm: "w-16 h-16",
    md: "w-20 h-20",
    lg: "w-40 h-40",
  };

  const iconSizes = {
    sm: "h-8 w-8",
    md: "h-10 w-10",
    lg: "h-16 w-16",
  };

  return (
    <Button
      onClick={onClick}
      disabled={disabled}
      className={`${buttonSizes[size]} rounded-full transition-all duration-300 ease-in-out ${
        disabled
          ? "bg-gray-500 disabled:opacity-100"
          : isMuted
            ? "bg-red-500 hover:bg-destructive"
            : audioDetected
              ? "bg-indigo-700"
              : "bg-green-500 hover:bg-green-600"
      }`}
      aria-label={isMuted ? "Unmute Microphone" : "Mute Microphone"}
      data-tour={tourKey}
    >
      {isMuted ? (
        <MicOff className={`${iconSizes[size]} text-white`} />
      ) : (
        <Mic className={`${iconSizes[size]} text-white`} />
      )}
    </Button>
  );
}
